/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Button, Image, Dropdown, NavLink, Badge, Card } from "react-bootstrap";
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useTranslate } from '../../../hooks/LanguageProvider';

import Logout from '../../Logout/Logout';
import { useTheme } from '../../../hooks/ThemeContext';
import usePermissions from '../../../hooks/usePermissions';
import { useUser } from "../../../context/UserContext";

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import axios from "axios";


import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/ar';
import 'dayjs/locale/es';
import 'dayjs/locale/es';
import 'dayjs/locale/zh-cn';
import { useAuth } from '../../../context/AuthContext';
import NavbarSearch from './NavbarSearch';
import { alarmLabelKeys } from '../../../config/alarms/alarmLabelKeys';
import { toast } from 'react-toastify';
import { formatNotificationPreview, parseServerUtcDate } from '../../../utilities/functions';


dayjs.extend(relativeTime);


const backendUrl = process.env.REACT_APP_BACKEND_URL;
const backendUrlGeoParc = process.env.REACT_APP_BACKEND_URL_GEO_PARC;



interface NavbarProps {
  changNavbar: boolean;
  onToggleSidebarInNavbar: () => void;
}

interface Notification {
  id_notification: number,
  id_groupe_alarme: number,
  id_user: number,
  id_vehicule: number,
  id_conducteur: number,
  type: string,
  message: string,
  severity: number,
  timestamp: string,
  state: number,
}

const NAVBAR_NOTIFICATION_MAX_AGE_DAYS = 2;
const NOTIFICATION_POLL_INTERVAL_MS = 10000;

const isNavbarNotificationFresh = (notification: Notification) => {
  const timestamp = parseServerUtcDate(notification.timestamp).getTime();
  if (Number.isNaN(timestamp)) return false;

  return Date.now() - timestamp <= NAVBAR_NOTIFICATION_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
};

const Navbar: React.FC<NavbarProps> = ({ onToggleSidebarInNavbar, changNavbar }) => {

  const userName = localStorage.getItem("username");
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const lastSeenNotificationIdRef = useRef<number | null>(null);
  const [showMenu, setShowMenu] = useState("");
  const { lang, setLang } = useTranslate();

  const { logout } = useAuth();     // récupéré au début du composant

  dayjs.locale(lang);

  const navigate = useNavigate();
  const { translate } = useTranslate();
  const handleLanguageChange = (newLang: any) => { setLang(newLang); };
  const user_id = localStorage.getItem("userid");
  const strLang = {
    en: translate('English'),
    fr: translate('French'),
    ar: translate('Arabic'),
    es: translate('Espagnol'),
    zh: translate('chinese'),
  };

  const { isDarkMode, toggleTheme } = useTheme();
  const { pathImg } = useUser();

  // Utilisation du hook
  const handleLogout = async () => {
    try {
      await logout(); // ⬅️ logout vient du contexte (useAuth)
      //navigate("/login"); // ⬅️ navigation après déconnexion
    } catch (error) {
      console.error("Error during disconnection: ", error);
    }
  };


  const [dropdownOpenNotification, setDropdownOpenNotification] = useState(false);
  const [dropdownOpenProfile, setDropdownOpenProfile] = useState(false);


  const handleToggleProfile = (DropdownOpen: any) => {
    setDropdownOpenProfile(DropdownOpen);
  };


  const toggleMenu = () => {
    setShowMenu(showMenu === "" ? "show" : "");
  };


  const getNotifications = async (id_user: string, state: number) => {
    try {
      // Prepare the request body
      const bodyData = JSON.stringify({
        state,
        limitValue: 100
      });

      // Make the fetch request
      const response = await fetch(
        `${backendUrl}/api/notification/read`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
          mode: "cors",
        }
      );

      // Check if the response status is OK (status code 200)
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
      }

      // Parse the JSON response
      const alarmResponse = await response.json();

      const freshNotifications = Array.isArray(alarmResponse)
        ? alarmResponse.filter(isNavbarNotificationFresh)
        : [];

      showNewNotificationToasts(id_user, freshNotifications);
      setNotifications(freshNotifications);
    } catch (error) {

      console.error("Error fetching alarms:", error);

      setNotifications([]);
      // Display a user-friendly message or handle the error in your UI logic
      // toast.error("An error occurred while fetching alarms. Please try again later.");
    }
  };

  const showGroupedNotificationToast = (
    notificationsToShow: Notification[],
    toastId: string
  ) => {
    if (!notificationsToShow.length) return;

    const firstNotification = notificationsToShow[0];
    const notificationUrl =
      notificationsToShow.length === 1
        ? `/notifications/${firstNotification.id_notification}?t=${Date.now()}`
        : "/notifications";
    const typeCounts = notificationsToShow.reduce<Record<string, number>>((counts, notification) => {
      const label = translate(getLabelFromType(notification.type));
      counts[label] = (counts[label] || 0) + 1;
      return counts;
    }, {});
    const summary = Object.entries(typeCounts)
      .slice(0, 3)
      .map(([label, count]) => (count > 1 ? `${count} ${label}` : label))
      .join(", ");
    const preview =
      notificationsToShow.length === 1
        ? formatNotificationPreview(firstNotification.message, translate, 72)
        : summary;

    toast(
      <div
        className="navbar-notification-toast-content"
        role="button"
        tabIndex={0}
        onClick={() => navigate(notificationUrl)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            navigate(notificationUrl);
          }
        }}
      >
        <span className="navbar-notification-toast-icon">
          <i className="las la-bell"></i>
        </span>
        <div className="navbar-notification-toast-body">
          <strong>
            {notificationsToShow.length === 1
              ? translate("New notification")
              : `${notificationsToShow.length} ${translate("new notifications")}`}
          </strong>
          {preview && <div className="navbar-notification-toast-preview">{preview}</div>}
          <div className="navbar-notification-toast-link">
            {translate("Open notifications")}
          </div>
        </div>
      </div>,
      {
        toastId,
        position: "bottom-right",
        autoClose: 8000,
        closeOnClick: true,
        icon: false,
        className: "navbar-notification-toast",
        progressClassName: "navbar-notification-toast-progress",
      }
    );
  };

  const showNewNotificationToasts = (idUser: string, freshNotifications: Notification[]) => {
    const storageKey = `geotrackin:last-navbar-notification-id:${idUser}`;
    const storedLastId = Number(localStorage.getItem(storageKey) || 0);
    const isInitialLoad = lastSeenNotificationIdRef.current === null;
    const lastSeenId = lastSeenNotificationIdRef.current ?? storedLastId;
    const currentMaxId = freshNotifications.reduce(
      (maxId, notification) => Math.max(maxId, Number(notification.id_notification) || 0),
      storedLastId
    );

    if (isInitialLoad) {
      const unseenNotifications = freshNotifications
        .filter((notification) => Number(notification.id_notification) > storedLastId)
        .sort((a, b) => Number(a.id_notification) - Number(b.id_notification));

      if (unseenNotifications.length > 0) {
        showGroupedNotificationToast(
          unseenNotifications,
          `navbar-notifications-entry-${idUser}-${currentMaxId}`
        );
      }

      lastSeenNotificationIdRef.current = currentMaxId;
      localStorage.setItem(storageKey, String(currentMaxId));
      return;
    }

    const newNotifications = freshNotifications
      .filter((notification) => Number(notification.id_notification) > lastSeenId)
      .sort((a, b) => Number(a.id_notification) - Number(b.id_notification));

    showGroupedNotificationToast(
      newNotifications,
      `navbar-notifications-batch-${currentMaxId}`
    );

    lastSeenNotificationIdRef.current = currentMaxId;
    localStorage.setItem(storageKey, String(currentMaxId));
  };


  useEffect(() => {
    if (user_id) {
      getNotifications(user_id, 1);

      const interval = setInterval(() => {
        getNotifications(user_id, 1);
      }, NOTIFICATION_POLL_INTERVAL_MS);

      return () => clearInterval(interval);
    }
  }, [user_id]);

  const handleToggleNotification = () => {
    setDropdownOpenNotification(!dropdownOpenNotification);
  };

  const roleId = localStorage.getItem("id_role");
  const { userPermissions } = usePermissions(roleId);
  const checkPermission = (idPermission: number): boolean => {

    return userPermissions.some(
      (permission) => permission.id_permission === idPermission
    );
  };



  const getLabelFromType = (value: string): string => {
    if (value === 'security_alert') return 'Security alert';
    if (value === 'security_report') return 'Security report';
    if (value === 'trip_detected') return 'Mission · Trip détecté';
    if (value === "chat_message") return "Chat message";
    return alarmLabelKeys[value as keyof typeof alarmLabelKeys] ?? value;
  };


  const handleLoginGeoParc = async () => {
    console.log("LogIn GeoParc");

    const currentApiKey = localStorage.getItem("api_key");

    if (!currentApiKey) {
      toast.error(translate("api_key_missing"), {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    const toastId = toast.loading(translate("logging_in"), {
      position: "bottom-right",
    });

    try {
      const response = await axios.post(
        `${backendUrl}/api/loginGeoParc`,
        { api_key: currentApiKey },
        { withCredentials: true }
      );

      const data = response.data;

      if (!data || !data.id_user) {
        toast.update(toastId, {
          render: translate("invalid_credentials"),
          type: "error",
          isLoading: false,
          autoClose: 3000,
          position: "bottom-right",
        });
        return;
      }

      const geoparcKeysToRemove = [
        "GeoploginTime",
        "GeopUserID",
        "Geopusername",
        "GeopRoleID",
        "geop_userPermissions",
        "geop_api_key",
        "geop_id_role",
        "geop_theme_mode",
        "geop_language",
        "geop_timezone",
      ];

      geoparcKeysToRemove.forEach((key) => localStorage.removeItem(key));

      const geoparcApiKey = String(data.api_key || currentApiKey);

      localStorage.setItem("GeoploginTime", String(Date.now()));
      localStorage.setItem("GeopUserID", String(data.id_user));
      localStorage.setItem("Geopusername", String(data.username ?? ""));
      localStorage.setItem("GeopRoleID", String(data.id_role ?? ""));
      localStorage.setItem("geop_api_key", geoparcApiKey);
      localStorage.setItem("geop_id_role", String(data.id_role ?? ""));
      localStorage.setItem(
        "geop_theme_mode",
        String(data.profile_settings?.theme_mode ?? "0")
      );
      localStorage.setItem(
        "geop_language",
        String(data.profile_settings?.language ?? "fr")
      );
      localStorage.setItem(
        "geop_timezone",
        String(data.profile_settings?.timezone ?? "")
      );

      toast.update(toastId, {
        render: translate("login_success_redirect"),
        type: "success",
        isLoading: false,
        autoClose: 1200,
        position: "bottom-right",
      });

      const geoparcUrl = new URL(String(backendUrlGeoParc));
      geoparcUrl.searchParams.set("api_key", geoparcApiKey);
      geoparcUrl.searchParams.set("source", "geotrackin");
      geoparcUrl.searchParams.set("t", String(Date.now()));

      window.location.replace(geoparcUrl.toString());
    } catch (error: any) {
      console.error("Login GEOP depuis GEOT error", error);

      toast.update(toastId, {
        render: error?.response?.data?.message || translate("login_failed"),
        type: "error",
        isLoading: false,
        autoClose: 3000,
        position: "bottom-right",
      });
    }
  };

  return (
    <div className={`iq-top-navbar  ${changNavbar ? "navbar-push" : "navbar-pool"}`} >
      <div className="iq-navbar-custom">
        <nav className="navbar navbar-expand-lg navbar-light p-0">
          <div className="iq-navbar-logo d-flex align-items-center justify-content-between">
            <i
              className={`las ${changNavbar ? "la-chevron-left" : "la-thumbtack"} wrapper-menu ${changNavbar ? "open" : ""}`}
              aria-label={changNavbar ? translate("Collapse sidebar") : translate("Pin sidebar")}
              title={changNavbar ? translate("Collapse sidebar") : translate("Pin sidebar")}
              onClick={onToggleSidebarInNavbar}
            > </i>

            <Nav.Link to="/" className={`header-logo`} as={NavLink}>
              <Image
                className="img-fluid rounded-normal light-logo"
                style={{ height: "22px", width: "136px", paddingLeft: 15 }}
                src={isDarkMode ? "asset/images/logo_dark.png" : "asset/images/logo.png"}
                alt="Logo" />
            </Nav.Link>

            <NavbarSearch />

          </div>

          <div className="d-flex align-items-center">
            <button onClick={toggleMenu} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-label="Toggle navigation" aria-expanded="true">
              <i className="ri-menu-3-line"></i>
            </button>
            <div className={`navbar-collapse collapse ${showMenu}`} id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto navbar-list align-items-center">

                {checkPermission(27) && (<li className="nav-item nav-icon dropdown" style={{ margin: "12px 5px" }} title={translate("Click here to access GEOPARC")}>
                  {
                    <button onClick={handleLoginGeoParc} className="gp">
                      <i className="las la-sign-in-alt" style={{ fontSize: "29px" }}></i>
                      <span style={{ fontSize: "16px" }}> GEOPARC</span>
                    </button >
                  }
                </li>)}

                <li className="nav-item nav-icon dropdown" style={{ margin: "0 5px" }}>
                  <NavDropdown
                    title={
                      <span>
                        <img src={`asset/images/small/flag-${lang}.png`} alt={lang} />
                        <span> {strLang[lang]}</span>
                      </span>
                    }
                    id="navbarScrollingDropdown"
                  >
                    <NavDropdown.Item onClick={() => handleLanguageChange('en')}>
                      <img src="asset/images/small/flag-en.png" alt="img-flag" className="img-fluid image-flag mr-2" /> {translate("English")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleLanguageChange('fr')}>
                      <img src="asset/images/small/flag-fr.png" alt="img-flag" className="img-fluid image-flag mr-2" /> {translate("French")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleLanguageChange('ar')}>
                      <img src="asset/images/small/flag-ar.png" alt="img-flag" className="img-fluid image-flag mr-2" /> {translate("Arabic")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleLanguageChange('es')}>
                      <img src="asset/images/small/flag-es.png" alt="img-flag" className="img-fluid image-flag mr-2" /> {translate("Spanish")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleLanguageChange('zh')}>
                      <img src="asset/images/small/flag-zh.png" alt="img-flag" className="img-fluid image-flag mr-2" /> {translate("chinese")}
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>



                <li className="nav-item nav-icon dropdown" style={{ margin: "0 5px" }}>
                  <div className="dropdown" onClick={toggleTheme} style={{ cursor: "pointer" }}>
                    {/* Display the icon based on the theme */}
                    {isDarkMode ? (
                      <i className="las la-moon" style={{ fontSize: "22px" }}></i> // Moon icon for dark theme
                    ) : (
                      <i className="las la-sun" style={{ fontSize: "22px" }}></i> // Sun icon for light theme
                    )}
                  </div>
                </li>

                <li className="nav-item nav-icon dropdown show" style={{ margin: "0 5px" }}>
                  <Dropdown onToggle={handleToggleNotification}>
                    <Dropdown.Toggle as="span" id="dropdownMenuButton5" className="search-toggle" href="#">
                      <div className="notification-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-bell"
                        >
                          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                        {notifications && notifications.length > 0 && (
                          <span className="notification-badge">
                            {notifications.length >= 100 ? "99+" : notifications.length}
                          </span>
                        )}
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu align="end" className="iq-sub-dropdown dropdown-menu" show={dropdownOpenNotification} aria-labelledby="dropdownMenuButton5">
                      <Card className="shadow-none m-0">
                        <Card.Body className="p-0">
                          <div className="custom-title p-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <h5 className="mb-0">{translate("Notifications")}</h5>
                              <Badge className="badge-card">{notifications && notifications.length >= 100 ? "99+" : notifications.length}</Badge>
                            </div>
                          </div>
                          <div className="px-3 pt-0 pb-0 sub-card">
                            {notifications && notifications.length > 0 ? (
                              notifications.slice(0, 7).map((notification) => (
                                <Link className="iq-sub-card" key={notification.id_notification}
                                  to={`/notifications/${notification.id_notification}?t=${Date.now()}`}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title={translate("View notification")}
                                  onClick={() => {
                                    fetch(`${backendUrl}/api/notification/update`, {
                                      method: "POST",
                                      headers: {
                                        "Content-Type": "application/json",
                                      },
                                      body: JSON.stringify({ id_notification: notification.id_notification }),
                                    })
                                      .then((response) => response.json())
                                      .then((data) => {
                                        if (user_id) getNotifications(user_id, 1);
                                        console.log("Updated notifications :", data);
                                      })
                                      .catch((error) => {
                                        console.error("None during the update :", error);
                                      });

                                    setTimeout(() => {
                                      setDropdownOpenNotification(false);
                                      window.location.reload();
                                    }, 10);
                                  }}
                                >
                                  <div className="media align-items-center custom-card py-3 border-bottom" style={{ paddingBottom: "0.5rem !important" }}>
                                    <div>
                                      {notification.type === 'security_alert' || notification.type === 'security_report' ? <i className={notification.type === 'security_alert' ? 'fas fa-shield-alt' : 'fas fa-file-alt'} style={{color:'#ff7b2c'}} aria-hidden="true" /> : <img className="avatar-30 rounded-small" src="../asset/images/icon-report/3.png" alt="01" />}
                                    </div>
                                    <div className="media-body ml-3">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <h6 className="notification-alarm-name mb-0">{translate(getLabelFromType(notification.type))}</h6>
                                        <small className="">
                                          <b>{dayjs(parseServerUtcDate(notification.timestamp)).fromNow()}</b>
                                        </small>
                                      </div>
                                      <small className="notification-preview mb-0">
                                        {formatNotificationPreview(notification.message, translate, 74)}
                                      </small>
                                    </div>
                                  </div>
                                </Link>
                              ))
                            ) : (
                              <p className="text-center p-2">{translate("No notifications available.")}</p>
                            )}
                          </div>
                          <>
                            <Link
                              to="/notifications"
                              className="right-ic btn btn-primary btn-block position-relative p-2"
                            >
                              {translate("See all notifications")}{" "}
                              <i className="las la-arrow-right"></i>
                            </Link>
                          </>

                        </Card.Body>
                      </Card>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>

                <li className="nav-item nav-icon dropdown" style={{ margin: "0 5px" }}>
                  <Dropdown onToggle={handleToggleProfile} show={dropdownOpenProfile}>
                    <Dropdown.Toggle as="span" id="dropdownMenuButton4" className="search-toggle" href="#">
                      <i className='las la-user' style={{ fontSize: "25px" }}></i>
                      <span className="d-none d-lg-inline ms-1 fw-semibold">
                        {userName}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ width: "auto", inset: "auto auto auto auto" }} className='dropdownProfile'>
                      <div className="card shadow-none border-0 m-0">
                        <div className="card-body p-0 text-center">
                          <div className="media-body profile-detail text-center">
                            <img src="asset/images/page-img/profile-bg.jpg" alt="profile-bg" className="rounded-top img-fluid mb-4" />
                            <img src={pathImg} className="rounded profile-img img-fluid avatar-70" alt='Profile' />
                          </div>
                          <div className="p-3">
                            <h5 className="mb-1">{userName}</h5>
                            <p className="mb-0"></p>
                            <div className="d-flex align-items-center justify-content-center mt-3">
                              <Button variant="outline-secondary" className="mr-2" onClick={() => navigate(`/profile`)} style={{ minWidth: "max-content", border: "1px solid #ddd", borderRadius: "5px" }}>
                                <i className="las la-user"></i> {translate("Profile")}
                              </Button>
                              <span style={{ minWidth: "max-content", border: "1px solid #ddd", borderRadius: "5px" }}>
                                <Logout onLogout={handleLogout} activeMenu={""} title={translate("Logout")} margin={'ml-1'} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
